PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>
PREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>
PREFIX ccf: <http://purl.org/ccf/>
PREFIX hasExactSynonym: <http://www.geneontology.org/formats/oboInOwl#hasExactSynonym>
PREFIX HRA: <https://purl.humanatlas.io/collection/hra-api>

SELECT DISTINCT ?root ?child ?parent ?label ?synonymLabel
FROM HRA:
WHERE {
  BIND("biomarkers" as ?root)

  {
    BIND("biomarkers" as ?child)
    BIND("biomarkers" as ?parent)
  }
  UNION
  {
    ?child ccf:ccf_pref_label ?label1 .
    OPTIONAL {
      {
        ?child hasExactSynonym: ?synonymLabel1 .
      }
      UNION
      {
        ?child rdfs:label ?synonymLabel1 .
      }
    }
    ?child ccf:ccf_biomarker_type ?parent .
    BIND (?parent_label AS ?parent)
  }
  UNION
  {
    [] ccf:ccf_biomarker_type ?label1 .
    BIND (?label1 AS ?child)
    BIND ("biomarkers" AS ?parent)
  }

  BIND(IF(?child = ?root, 'Biomarkers', STR(?label1)) as ?label)
  BIND(STR(?synonymLabel1) as ?synonymLabel)
  FILTER(!CONTAINS(STR(?child), 'https://purl.humanatlas.io/asct-b/'))
}
ORDER BY ?label ?child
